import { observable, action, decorate } from "mobx";

class AppState {
  count = 0;
  appRoutine = {
    count: 2,
    //apiUrl: "http://localhost:5000/api/",
    apiUrl: "https://book.royaltravelclub.co.uk/api/",
    logedIn: false,
    currentPage: "Home",
    version: '1.7.4',
    loading: false,
    msgOpen: false,
    msgText: '',
    msg: {
      open: false, 
      text: '',
      type: 'info',
    }

  }
  user = {};
  loggedInUser = {};
  supplier = {};
  client = {};
  vehicle = {};
  driver = {};
  bookings = {
    date: '',
    activeSearch: false,
    period: 'month',
    searchBy: 'NAME',
    searchFor: '',
    expandAll: false,
    data: {
      transfers: {},
    },
    dates: {
      transfers: {},
    },
  };
  
  viewBooking = {
    ref: '',
    expandAll: false,
    data: {
      transfers: {},
    },
    dates: {
      transfers: {},
    },
  };

  increment() {
    this.count++;
  }

  decrement() {
    this.count--;
  }


  login(userDetails){
    this.appRoutine.logedIn = true;
    this.loggedInUser = userDetails;
  }

  logout(){
    this.appRoutine.logedIn = false;
    this.loggedInUser = {};
  }

  changePage(newPage){
    this.appRoutine.currentPage = newPage; 
  }
}

decorate(AppState, {
  appRoutine: observable,
  user: observable,
  loggedInUser: observable,
  supplier: observable,
  client: observable,
  driver: observable,
  vehicle: observable,
  bookings: observable,
  viewBooking: observable,
  count: observable,
  increment: action,
  decrement: action,
  changePage: action,
  login: action,
  logout: action,
})

export default AppState;